import axios, { getData } from 'lib/axios'

export const getAllCandidate = async (rows, page, searchItem) => {
  const response = await axios.get(
    `/recruitment/candidates?per-page=${rows}&page=${page}${searchItem}`
  )
  return getData(response)
}

export const updateCandidate = async (id, data) => {
  return axios.put(`/recruitment/candidate/${id}`, data).then(getData)
}

export const getCandidate = async (id) => {
  const response = await axios.get(`/recruitment/candidates/${id}`)
  return getData(response)
}

export const parseProgress = async (page, data) => {
  const response = await axios.post(`/recruitment/candidates?page=${page}`, data)
  return getData(response)
}

export const removeTalent = async (data) => {
  const response = await axios.post(`/recruitment/candidates/destroy`, data)
  return getData(response)
}

export const keepTalent = async (id) => {
  return axios.get(`/recruitment/candidates/${id}/keep`).then(getData)
}

export const redundantResume = async () => {
  return axios.get('/recruitment/redundant-candidate').then(getData)
}

export const getUploadHistory = async () => {
  const response = await axios.get(`/recruitment/resume-uploads`)
  return getData(response)
}

export const inprogressParse = async () => {
  return axios.get('/recruitment/uploaded-resume-incomplete').then(getData)
}

export const completedParse = async (rows, page) => {
  return axios
    .get(`/recruitment/uploaded-resume-complete?per-page=${rows}&page=${page}`)
    .then(getData)
}

export const resumeByBatch = async (batch) => {
  return axios.get(`/recruitment/uploaded-resume-complete/${batch}`).then(getData)
}

export const searchCandidate = async (rows, page, searchTerm, data) => {
  const response = await axios.get(
    `/recruitment/candidates?per-page=${rows}&page=${page}&search=${searchTerm}`,
    data
  )
  return getData(response)
}

export const listCalendar = async (year, month) => {
  const response = await axios.get(`recruitment/recruiter-calendar?year=${year}&month=${month}`)
  return getData(response)
}

export const getInterviewSlot = async (interviewId, data) => {
  const response = await axios.get(`recruitment/interviews/${interviewId}`, data)
  return getData(response)
}

export const getSample = async (id) => {
  return axios.get(`/recruitment/sample-resume?id=${id}`).then(getData)
}

export const getRedundantTalent = async (email, page, rows, searchTerm) => {
  const response = await axios.get(
    `/recruitment/redundant-candidate/${email}?page=${page}&perPage=${rows}${searchTerm}`
  )
  return getData(response)
}

export const getRequestVideoInterview = async (id) => {
  const response = await axios.get(`recruitment/request-user-video-interview/${id}`)
  return getData(response)
}

export const postRequestVideoInterview = async (id, data) => {
  const response = await axios.post(`recruitment/request-user-video-interview/${id}`, data)
  return getData(response)
}

export const getTalentQuota = async () => {
  const response = await axios.get(`recruitment/subscription_quota`)
  return getData(response)
}
